module.exports = __webpack_public_path__ + "static/img/cert.c33a3810.svg";